export const SUPPORT_EMAIL = 'clientsupport@theticketfairy.com'